import Vue from 'vue'
import VueRouter from 'vue-router'
import WindowLayer from '@/v2/views/SaaS/WindowLayer.vue'
import Reservation from '@/v2/views/SaaS/Reservation/Reservation.vue'

Vue.use(VueRouter)

/*
 * 일렉트론과 같은 구조다. WindowLayer 가 인증(IPC)·레이아웃(.cont_fix)·준비 게이트(isReady)를
 * 맡고, 그 안의 <router-view> 로 예약 화면을 그린다.
 */
const routes = [
    {
        path: '/w/reservation',
        component: WindowLayer,
        children: [
            { path: '', name: 'Reservation', component: Reservation },
        ],
    },
    { path: '*', redirect: '/w/reservation' },
]

const router = new VueRouter({
    mode: 'history',
    routes,
})

export default router
